module.exports = __webpack_public_path__ + "static/media/G1-25-Tessa-Rubis-cod56.509d64fc.png";